interface MomentIntelligenceIconProps {
  size?: number;
  className?: string;
}

export default function MomentIntelligenceIcon({ 
  size = 64, 
  className = "" 
}: MomentIntelligenceIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Speech bubble */}
      <path
        d="M 8 12 C 8 8 8 4 12 4 L 52 4 C 56 4 56 8 56 12 L 56 40 C 56 44 56 48 52 48 L 22 48 L 12 58 L 12 48 C 8 48 8 44 8 40 Z"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        strokeLinejoin="round"
      />
      
      {/* Central emotion dot - highlighted (moment identified) */}
      <circle
        cx="32"
        cy="14"
        r="4"
        fill="currentColor"
      />
      
      {/* Additional emotion indicators - smaller dots showing multiple moments */}
      <circle
        cx="22"
        cy="14"
        r="2"
        fill="currentColor"
        opacity="0.6"
      />
      
      <circle
        cx="42"
        cy="14"
        r="2"
        fill="currentColor"
        opacity="0.6"
      />
      
      {/* First row of pattern bars - lighter, bold, lighter */}
      <rect
        x="16"
        y="26"
        width="8"
        height="3"
        rx="1.5"
        fill="currentColor"
        opacity="0.4"
      />
      
      <rect
        x="26"
        y="25"
        width="12"
        height="5"
        rx="2.5"
        fill="currentColor"
      />
      
      <rect
        x="40"
        y="26"
        width="8"
        height="3"
        rx="1.5"
        fill="currentColor"
        opacity="0.4"
      />
      
      {/* Second row of pattern bars - bold, empty (boundary only), bold */}
      <rect
        x="16"
        y="34"
        width="10"
        height="5"
        rx="2.5"
        fill="currentColor"
      />
      
      <rect
        x="28"
        y="35.5"
        width="14"
        height="3"
        rx="1.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      />
      
      <rect
        x="44"
        y="34"
        width="6"
        height="5"
        rx="2.5"
        fill="currentColor"
      />
    </svg>
  );
}
